import { render, staticRenderFns } from "./list4.vue?vue&type=template&id=a1a7896e&"
import script from "./list4.vue?vue&type=script&lang=js&"
export * from "./list4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports